var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useEffect, useRef } from 'react';
const useStorePreviousInt = (previousInt) => {
    _react_refresh_temp_1();
    const ref = useRef();
    useEffect(() => {
        ref.current = previousInt;
    });
    return ref.current;
};
_react_refresh_temp_1(useStorePreviousInt, "8uVE59eA/r6b92xF80p7sH8rXLk=");
export default useStorePreviousInt;
